<template>
	<header
		:class="[
			`core-plan-detail-hero hero--partial-height hero--${planHero.slug} display-flex-md align-items-center-md`,
			{ 'text-color-white': darkHeroTheme }
		]"
		:style="`background-image: url(${planHero.heroGraphic})`"
	>
		<div class="container position-relative col-12-mdo">
			<div class="grid-md gutters-300-md">
				<div class="col-8-md col-6-lg">
					<ul :class="['overline-small ml-25 display-none-smo', { 'text-color-white': darkHeroTheme }]">
						<li class="display-inline-block">
							<BaseLink :link="investmentsLink" :classes="'text-color-current-color'" />
						</li>
						<li class="display-inline-block">
							<BaseSvgIcon name="chevron" dir="right" class="ml-50 mr-50" />
							<BaseLink :link="comparePlansLink" :classes="'text-color-current-color'" />
						</li>
						<li class="display-inline-block muted-reversed">
							<BaseSvgIcon name="chevron" dir="right" class="ml-50 mr-50" />
							{{ planHero.name }}
						</li>
					</ul>
					<h1 :class="['heading-1 mt-50-smo text-align-center-smo', { 'text-color-white': darkHeroTheme }]">
						{{ planHero.name }}
					</h1>
					<p class="text-align-center-smo delta-md">{{ planHero.headline }}</p>

					<div v-if="planHero.returns" class="display-flex-md align-items-center-md mt-100 mt-150-md">
						<PlanTargetReturnsProfile
							:target-returns-profile="planHero.returns"
							:dark-theme="darkHeroTheme"
							class="mr-auto-smo ml-auto-smo"
						/>
						<slot name="heroCta"></slot>
					</div>
				</div>
			</div>
		</div>
	</header>
</template>
<script setup lang="ts">
import { Link } from 'types/layout';
import { PlanHero } from 'types/plan';
import PlanTargetReturnsProfile from '@components/plan/plan-target-returns-profile.vue';

interface Props {
	planHero: PlanHero;
	darkHeroTheme?: boolean;
}

withDefaults(defineProps<Props>(), {
	darkHeroTheme: true
});

const investmentsLink: Link = {
	text: 'Investments',
	router: 'investments'
};

const comparePlansLink: Link = {
	text: 'Compare core plans',
	router: 'compare-core-plans'
};
</script>

<style lang="scss">
@use '../../styles/constants/colors.scss' as *;

.core-plan-detail-hero {
	background-position: bottom right;
	background-size: contain;
	background-repeat: no-repeat;
	position: relative;

	&.hero--supplemental-income {
		background-color: slate(80);
		background-size: auto 90%;
	}
	&.hero--balanced-investing,
	&.hero--venture-capital {
		background-color: slate(40);
	}
	&.hero--long-term-growth {
		background-color: token('content-primary');
	}
}
</style>
